import {z} from 'zod';
import configDay from '../../../shared/mixins/configDay';

export const id = z.string().uuid();

export const nullableId = id.nullable().default(null);

export const nullableString = z.string().nullable().default(null);

export const nullableNumber = z.number().nullable().default(null);

export const nonNegativeInt = z.number().int().nonnegative();

export const localDateTime = z
    .string()
    .datetime({local: true})
    .transform(datetime => new Date(datetime));

export const date = z
    .string()
    .date()
    .transform(datetime => new Date(datetime));

export const legacyApiDate = z
    .string()
    .transform(datetime => configDay.methods.dateFromString(datetime));

export const isoDate = z.preprocess(
    arg => (typeof arg === 'string' ? new Date(arg) : arg),
    z.date()
);

export const time = z.string().time();
